import type { CashListSelectorRules } from '@pflegenavi/frontend/api-nursing-home';

export enum ChangeCashMode {
  Deposit = 'deposit',
  Withdraw = 'withdraw',
  Adjust = 'adjust',
  Transfer = 'transfer',
}

export interface CashState {
  [factor: number]: number;
}

/**
 * Cash-list selector rules per ChangeCashForm mode. Each non-transfer mode
 * gets a single rule set; transfer gets one rule set per side.
 *
 * When the form is rendered without this prop the dropdown shows every cash
 * list from the configuration (current legacy behaviour).
 */
export interface ChangeCashSelectorRulesByMode {
  [ChangeCashMode.Withdraw]?: CashListSelectorRules;
  [ChangeCashMode.Deposit]?: CashListSelectorRules;
  [ChangeCashMode.Adjust]?: CashListSelectorRules;
  [ChangeCashMode.Transfer]?: {
    outgoing?: CashListSelectorRules;
    incoming?: CashListSelectorRules;
  };
}
